var render = function render(){var _vm=this,_c=_vm._self._c;return _c('cluji-card',{attrs:{"title":"Cœurs"}},[_c('love-message-form')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }